import { InjectedProviderProps } from 'Components/Core/InjectedPropsContext/types';
import { ChangeEventWithData } from 'Components/Core/types';
import { RootState } from 'Data/Redux';
import { IQuantity } from 'Data/ViewModels/Core/IQuantity';
import { Selector } from 'react-redux';
import { SetValuePayLoad } from '../Core/WorksheetEditorInjectedPropsProvider/types';

/**
 * A type to store the data returned from the API
 * Used in the Available Tests grid, and the Show More Information Record grid.
 */
export type MaximumDryDensityTest = {
  dateSampled: Date;
  id: string;
  material: string;
  oversizePercent: string;
  oversizeSieveApertureSize: number | null;
  oversizeSieveApertureSizeId: string;
  maximumDryDensity: any;
  optimumMoistureContent: string;
  sampleId: string;
  selected: boolean;
  testIsInvalid: boolean;
};

/**
 * A type to store an Assigned Value Test
 */
export type AssignedValueTest = {
  CompactionMethod?: string;
  DateAssigned?: Date;
  AssignedMaximumDryDensity?: IQuantity;
  AssignedOptimumMoistureContent?: number;
  TestPortionId?: string;
  AssignedValueMddTestSourceEntities?: AssignedValueMddTestSourceEntities[];
};

export type AssignedValueMddTestSourceEntities = {
  TestId: string;
  DateSampled: Date;
  OversizePercent: number;
  SampleId: string;
  MaximumDryDensity: IQuantity;
  OptimumMoistureContent: number;
};

export const maxTestsToSelect = 6;

export type AmddInjectedConsumerProps = {
  name?: string;
  prefixName?: (name: string) => string;
  messages?: Array<any>;
  value?: any;
  onChange?: (_: ChangeEventWithData) => void;
};

export type AmddInjectedProviderData = {
  setValue: (update: SetValuePayLoad) => void;
  stateSelector: Selector<RootState, any>;
};

export type AmddInjectedProviderProps = InjectedProviderProps & {
  prefixName?: (name: string) => string;
  namePrefix?: string;
  consumerLabel?: string;
  disabled?: boolean;
  selectors?: {
    // config?: Selector<RootState, any>;
    // label?: Selector<RootState, { label: string } | undefined>;
    messages?: Selector<RootState, { messages: Array<any> } | undefined>;
    // limit?: Selector<RootState, any>;
    // measuredUsing?: Selector<RootState, { measuredUsing: any } | undefined>;
    // format?: Selector<RootState, { format: string } | undefined>;
    value?: Selector<RootState, { value: any } | undefined>;
    // comparisonSymbol?: Selector<RootState, { comparisonSymbol: any } | undefined>;
    // onChange?: Selector<RootState, { onChange: (_: ChangeEventWithData) => void }>;
  };
  setValue?: (payload: SetValuePayLoad) => void;
  onChange?: (_: ChangeEventWithData) => void;
};
